<script>
  import { fade } from 'svelte/transition'
  import { language, toggleLanguage } from '../i18n/i18n';
</script>

<style>
  section {
    background: var(--blue);
    min-height: 100vh;
  }

  header {
    text-align: center;
    color: var(--white);
    display: flex;
    align-items: center;
    padding: 2rem;
  }

  img {
    display: block;
    margin-right: 2rem;
    width: 6rem;
  }

  h2 {
    font-size: 2rem;
  }

  div {
    flex: 1;
    padding: 4rem;
    width: 90vw;
    margin: 0 auto;
    background: var(--white);
    border-radius: var(--radius);
    margin-bottom: 4rem;
  }

  @media (min-width: 767px) {
    div {
      width: 50vw;
      max-width: 80rem;
    }
  }


  button {
    width: 3.2rem;
    height: 3.2rem;
    background-color: var(--white);
    color: var(--blue);
    margin: 0 1.2rem;
    border-radius: 90rem;
    position: absolute;
    top: 1rem;
    right: 0;
    border: 2px solid;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
</style>

<section in:fade|global={{duration: 300}}>
  <header>
    <img src="logo-white.svg" alt="">
    <h2>Contract Keeper</h2>
  </header>
  <div>
    <slot />
    <button on:click={toggleLanguage}>{$language == 'en' ? 'fr' : 'en'}</button>
  </div>
</section>
